import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUsers, selectUsers } from "../users/usersSlice";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";

import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Divider from "@material-ui/core/Divider";
import { Typography } from "@material-ui/core";
import {
  // updateOrderDetails,
  // updateOrderProduct,
  setViewing,
  // setOrderUser,
  selectInvoices,
  // createOrder,
} from "./invoicesSlice";

// import { fetchProducts, selectProducts } from "../products/productsSlice.js";

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  tabBar: {
    // backgroundColor: ' rgba(0, 0, 0, 0.08)',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    // alignItems: 'center',
    borderRadius: "10px",
    backgroundColor: "#FFF",
    padding: 0,
  },
  heading: {},
  form: {
    // width: '100%', // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
    // padding: 25,
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  headerContainer: {
    padding: theme.spacing(2),
    // color: '#fafafa',
    color: "#fff",
    backgroundColor: "#42494E",
  },
  subHeader: {
    margin: theme.spacing(2),
    marginBottom: 0,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#42494E",
    color: "#FFF",
  },
  tabContent: {
    display: "flex",
    flexFlow: "column nowrap",
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },

  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    marginRight: 8,
    color: "#fff",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
  dataList: {
    width: "7rem",
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

export default function Orders(props) {
  const { product } = props;
  const classes = useStyles();
  // const edit = props.edit;
  const { user } = useSelector(selectUsers);
  const { invoicesList, viewing, invoice } = useSelector(selectInvoices);
  // const {productList} = useSelector(selectProducts);

  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [viewInvoice, setViewInvoice] = useState(false);

  // cart
  const [invoiceNumber, setInvoiceNumber] = useState("");

  let timeZoneOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZone: "Australia/Sydney",
  };

  useEffect(() => {
    // opens dialog after list order has been loaded
    if (viewing && invoice !== {}) {
      setViewInvoice(true);
      setOpen(true);
      setInvoiceNumber(invoice.id);
    }
  }, [viewing, user]);

  const handleClickOpen = () => {
    setViewInvoice(false);
    setViewing(false);
    setInvoiceNumber("");
    setOpen(true);
  };

  const handleClose = () => {
    setViewing(false);
    setInvoiceNumber("");
    setOpen(false);
    setViewInvoice(false);
  };

  // l;j;jkl
  const [checked, setChecked] = useState([0]);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const [search, setSearchTerm] = useState("");

  return (
    <div>
      <IconButton
        aria-label={viewInvoice ? "edit user" : "add user"}
        style={
          product
            ? { marginLeft: 0, display: "none" }
            : { marginLeft: 0, display: "none" }
        }
      >
        <AddCircleIcon
          style={
            product ? { marginRight: 0 } : { marginRight: 0, color: "#fff" }
          }
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {viewInvoice && `Invoice #${invoice.id}`}
        </DialogTitle>

        <div style={{ padding: 24, display: "flex" }}>
          {viewInvoice ? (
            <div
              style={{
                display: "flex",
                marginBottom: 24,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "rgb(64, 132, 243)",
                  paddingTop: 10,
                  paddingBottom: 10,
                }}
              >
                Invoice Details
              </div>
              <div style={{ marginLeft: 24 }}>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div style={{ marginRight: 60 }}>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Client ID: </div>
                      <span style={{ fontWeight: "normal" }}>
                        {invoice.clientID}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Xero ID:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {invoice.xeroID}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Created At:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {new Intl.DateTimeFormat(
                          "en-AU",
                          timeZoneOptions
                        ).format(new Date(invoice.createdAt))}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Updated At:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {new Intl.DateTimeFormat(
                          "en-AU",
                          timeZoneOptions
                        ).format(new Date(invoice.updatedAt))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>{" "}
            </div>
          ) : (
            <div></div>
          )}
          {viewInvoice ? (
            <div
              style={{
                display: "flex",
                marginBottom: 24,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "rgb(64, 132, 243)",
                  paddingTop: 10,
                  paddingBottom: 10,
                }}
              >
                Xero Details
              </div>
              <div style={{ marginLeft: 24 }}>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div style={{ marginRight: 60 }}>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Client ID: </div>
                      <span style={{ fontWeight: "normal" }}>
                        {invoice.clientID}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Xero ID:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {invoice.xeroID}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Created At:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {new Intl.DateTimeFormat(
                          "en-AU",
                          timeZoneOptions
                        ).format(new Date(invoice.createdAt))}
                      </span>
                    </div>
                    <div style={{ width: "30rem", display: "flex" }}>
                      <div className={classes.dataList}>Updated At:</div>
                      <span style={{ fontWeight: "normal" }}>
                        {new Intl.DateTimeFormat(
                          "en-AU",
                          timeZoneOptions
                        ).format(new Date(invoice.updatedAt))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>{" "}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: "bold",
            padding: 24,
            display: "flex",
            marginTop: 12,
            color: "rgb(64, 132, 243)",
          }}
        >
          Links
        </div>
      </Dialog>
    </div>
  );
}
